import { getDataFromServer } from '../../../util';

export class ClusterChartModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchClusterChartData = async (payload) => {
    const { modelId } = payload;
    const params = { modelId };

    const url = `${this.baseURL}/clusters`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (data) {
      const { clusterList } = data;

      return clusterList.map((clusterItem, clusterIndex) => {
        return { ...clusterItem, clusterIndex };
      });
    }

    return [];
  };
}
